import React, { useEffect, useState } from 'react'
import InputText from '../../../shared/input/new/InputText'
import InputSelectMultiple from '../../../shared/input/new/InputSelectMultiple'
import Btn from '../../../shared/button/Btn'
import { addNewPageOrMenu, updatePageOrMenu } from '../../../../features/admin5/admin5Slice'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import InputSelect from '../../../shared/input/new/InputSelect'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
`

const roleDatas = [
    {
        id: 2,
        value: "EgeYurtAdmin",
        text: "Ege Yurt Admin"
    },
    {
        id: 3,
        value: "DigitalLogisticsAdmin",
        text: "Dijital Lojistikçi"
    },
    {
        id: 4,
        value: "CooperativeAdmin",
        text: "Kooperatif"
    },
    {
        id: 5,
        value: "ShipperAdmin",
        text: "Yük Veren"
    },
    {
        id: 6,
        value: "DigitalLogisticsShipperAdmin",
        text: "Dijitla Lojistikçinin Yük Vereni"
    }
]

const typeDatas =  [
    {
        id: 1,
        value: "permission",
        text: "Yetki"
    },
    {
        id: 2,
        value: "default",
        text: "Herkeste Olmalı"
    },
    
]

const SayfaGuncelle = ({item}) => {
    
    const dispatch = useDispatch()
    const { selectedPage, selectedMenu } = useSelector((state) => state.admin5)
    const [selectedType, setSelectedType] = useState(null);
    const [data, setData] = useState(null)
    const [pageDesc, setPageDesc] = useState("")
    const [pageSlug, setPageSlug] = useState("")

    useEffect(() => {
        setData(item)
        setPageDesc(selectedPage.description)
        setPageSlug(selectedPage.slug)
        setSelectedType(typeDatas.find(item =>selectedPage.permissions.$values[0].permissionType === item.value ))
    }, [selectedPage])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    
    const handleSubmit = () => {
        const addData = {
            claimId: item.id,
            name: data.name,
            description: pageDesc,
            type: selectedType.value,
            slug: pageSlug,
            subLinkId: selectedMenu.id,
        }
        dispatch(updatePageOrMenu(addData))
    }

  return (
    <Container className="input-list">
        <InputText data={data?.name} setData={(e) => handleChange(e)} name={`name`} labelText='Rol Adı' inputWidth={"100%"} />
        <InputText data={pageDesc} setData={(e) => setPageDesc(e.target.value)} name={"description"} labelText='Sayfa Adı' inputWidth={"100%"} />
        <InputText data={pageSlug} setData={(e) => setPageSlug(e.target.value)} name={"slug"} labelText='Sayfa Uzantısı' inputWidth={"100%"} />
        <InputSelect data={selectedType?.text} setData={setSelectedType} labelText='Yetki Tipi' name={`selectedType${item.id}`} inputWidth={"100%"} initialOptions={typeDatas} />
        <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={handleSubmit} >Güncelle</Btn>
    </Container>
  )
}

export default SayfaGuncelle